import messages from './cmsRichText.json' with { type: 'json' };

export const cmsRichTextEn: Readonly<typeof messages> = messages;
